import { PropsWithChildren, createContext, useContext } from 'react';
import { useDeviceGeolocation, useMap } from 'rwl-ui';

type GeolocationContextType = Omit<
    ReturnType<typeof useDeviceGeolocation>,
    'requestGeolocation'
> & {
    requestGeolocation: (zoomLevel?: number) => void;
};

const GeolocationContext = createContext<GeolocationContextType | undefined>(
    undefined
);

type GeolocationProviderProps = unknown;

export const GeolocationProvider = ({
    children,
}: PropsWithChildren<GeolocationProviderProps>) => {
    const { map } = useMap();
    const deviceGeolocation = useDeviceGeolocation();

    return (
        <GeolocationContext.Provider
            value={{
                ...deviceGeolocation,
                requestGeolocation: (zoomLevel?: number) =>
                    deviceGeolocation.requestGeolocation((loc) => {
                        if (map && loc) {
                            map.setCenter({
                                lat: loc.coords.latitude,
                                lng: loc.coords.longitude,
                            });
                            if (zoomLevel) {
                                map.setZoom(zoomLevel);
                            }
                        }
                    }),
            }}
        >
            {children}
        </GeolocationContext.Provider>
    );
};

export const useGeolocation = () => {
    const context = useContext(GeolocationContext);
    if (context === undefined) {
        throw new Error(
            'useGeolocation must be used within a GeolocationProvider'
        );
    }
    return context;
};
